// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Account } from './account';
import { Manufacturer } from './manufacturer';
import { DocSubmitTypeEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class DocSubmitType extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Enum key */
  id!: DocSubmitTypeEnum;
  /** String(100) */
  name!: string;
  /** Inv FK invoiceDocSubmitTypeId */
  accounts!: Account[];
  /** Inv FK poDocSubmitTypeId */
  manufacturers!: Manufacturer[];
}

